import type { CSSProperties, ReactNode } from "react"

interface IconProps {
  children: ReactNode
  size?: number
  viewBox?: string
  className?: string
  primaryColor?: string
  secondaryColor?: string
}

type IconStyle = CSSProperties & {
  "--icon-primary"?: string
  "--icon-secondary"?: string
}

function getIconStyle(primaryColor?: string, secondaryColor?: string): IconStyle | undefined {
  if (!primaryColor && !secondaryColor) return undefined

  const style: IconStyle = {}
  if (primaryColor) style["--icon-primary"] = primaryColor
  if (secondaryColor) style["--icon-secondary"] = secondaryColor
  return style
}

export const Icon = ({
  children,
  size = 20,
  viewBox = "0 0 20 20",
  className = "",
  primaryColor,
  secondaryColor,
}: IconProps) => {
  // Check if a text color class is provided in className
  // If not, apply default colors. If yes, use only the provided className.
  // Note: This can be replaced with tailwind-merge's cn() utility if more
  // complex class merging is needed in the future.
  const hasTextColor = className && /\btext-/.test(className)
  const defaultColors = "text-muted"
  const finalClassName = hasTextColor ? className : `${defaultColors} ${className}`.trim()
  const style = getIconStyle(primaryColor, secondaryColor)

  return (
    <svg
      width={size}
      height={size}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={finalClassName}
      style={style}
      aria-hidden="true"
    >
      {children}
    </svg>
  )
}
